import { Icon } from '@mui/material';
import Button from '../Button';
import styles from './ImageDropzone.module.scss';
import { useRef, useState } from 'react';
import { Text } from '../typography';
import { isBlockedFile } from '../files/utils';

export default function MultiFileDropzone({ onChange, loading, accept }) {
  const inputRef = useRef();
  const [dragOver, setDragOver] = useState(false);
  const imagesOnly = accept?.startsWith('image/');

  const handleButtonClick = () => {
    if (inputRef.current) inputRef.current.click();
  };

  const handleInputChange = (e) => {
    if (onChange && e.target.files.length > 0) {
      const rejected = Array.from(e.target.files).filter(isBlockedFile);

      if (rejected.length) {
        alert(
          `These file types are not allowed: ${rejected
            .map((f) => f.name)
            .join(', ')}`,
        );
        return;
      }
      onChange(Array.from(e.target.files));
    }
  };

  function handleDragOver(e) {
    e.preventDefault();
    setDragOver(true);
  }
  function handleDragLeave(e) {
    e.preventDefault();
    setDragOver(false);
  }
  function handleDrop(e) {
    e.preventDefault();
    setDragOver(false);
    if (onChange && e.dataTransfer.files.length > 0) {
      onChange(Array.from(e.dataTransfer.files));
    }
  }
  return (
    <div
      className={`${styles.container} ${dragOver ? styles.dragOver : ''}`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      tabIndex={0}
      aria-label="Add Files"
    >
      <Icon sx={{ fontSize: '3rem' }} className={styles.icon}>
        photo_camera
      </Icon>
      <Text noMargin weight="semiBold">
        Drag and drop files to upload
      </Text>
      <Button
        className={styles.button}
        variant="secondary"
        size="sm"
        outlined
        value={imagesOnly ? 'Select Images' : 'Select Files'}
        onClick={handleButtonClick}
        type="button"
      />
      <input
        type="file"
        style={{ display: 'none' }}
        multiple
        ref={inputRef}
        onChange={handleInputChange}
        accept={accept || '*/*'}
      />
    </div>
  );
}
